import "./aioption.scss";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
function AiOption(props) {
  const handleClick = () => {
    if (props.createNewChat) {
      props.createNewChat();
    }
  };

  const {
    leftClass = ``,
    leftText = ``,
    centerClass = ``,
    centerText = ``,
    rightClass = ``,
    rightText = ``,
    plusIcon = ``,
    secondIcon = ``,
    customContainerClass = ``,
  } = props;

  return (
    <Container className={`aioption-container ${customContainerClass}`}>
      <div className="aioption-content gx-1" onClick={handleClick} >
        <div className="first-column">
          <div className={`content-left ${leftClass}`}>{leftText}</div>
          <div className={`${plusIcon}`}> </div>
          <div className={`${secondIcon}`}></div>
        </div>
        <div className="second-column">
          <div className={`content-center ${centerClass}`}>{centerText}</div>
        </div>
        <div className="third-column">
          <div className={`content-right ${rightClass}`}>{rightText}</div>
        </div>
      </div>
    </Container>
  );
}

export default AiOption;
